const memoryCache = new Map();
const DEFAULT_TTL = 2 * 60 * 1000;

export const readPageCache = (key, ttl = DEFAULT_TTL) => {
  const cached = memoryCache.get(key);
  if (!cached) return null;
  if (Date.now() - cached.timestamp > ttl) return null;
  return cached.data;
};

export const writePageCache = (key, data) => {
  memoryCache.set(key, {
    timestamp: Date.now(),
    data,
  });
};

export const clearPageCache = (key) => {
  if (key) {
    memoryCache.delete(key);
    return;
  }
  memoryCache.clear();
};
